import script from "./media.vue?vue&type=script&setup=true&lang=ts"
export * from "./media.vue?vue&type=script&setup=true&lang=ts"

import "./media.vue?vue&type=style&index=0&id=32a09c62&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a09c62"]])

export default __exports__